"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.groupHisaiSortReducer = exports.groupHisaiSortActions = exports.TYPES = exports.INIT_STATE = exports.CONTENTS = void 0;
var _reduxActions = require("redux-actions");
var _Consts = require("../common/consts/Consts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// アクションタイプの接頭辞
const PREFIX = _Consts.CONSTS.COMMON_ACTION_PREFIX + 'Sort';

// 表示コンテンツ
const CONTENTS = exports.CONTENTS = {
  SEARCH: 'search',
  DETAIL: 'detail',
  SET_POST: 'setPost',
  DELETE: 'delete'
};

// 初期状態
const INIT_STATE = exports.INIT_STATE = {
  containerInfo: {
    dispContent: CONTENTS.SEARCH,
    scrollTop: {
      index: 0,
      scrollY: 0,
      noSticky: false
    }
  },
  searchConditions: {
    subject: '',
    content: ''
  },
  searchResult: [],
  grouphisaiDetail: {
    hisaiKbn: ''
  },
  selectHisaiKbnCd: '',
  selectSeq: '',
  previousView: '',
  paging: {
    viewNum: 50,
    currentPage: 0
  },
  search: false
};

// アクションタイプ
const TYPES = exports.TYPES = {
  // 検索条件変更
  CHANGE_SEARCH_CONDITION: PREFIX + 'ChangeSearchCondtion',
  // 検索結果設定
  SET_SEARCH_RESULT: PREFIX + 'SetSearchResult',
  // 掲載先（グループ被災情報区分）設定
  SET_GROUPHISAI_KBN: PREFIX + 'SetGrouphisaiKbn',
  // グループ被災情報詳細設定
  SET_GROUPHISAI_DETAIL: PREFIX + 'SetGrouphisaiDetail',
  // 検索画面遷移
  GO_SEARCH: PREFIX + 'GoSearch',
  // 詳細画面遷移
  GO_DETAIL: PREFIX + 'GoDetail',
  // 掲載先設定画面遷移
  GO_SET_POST: PREFIX + 'GoSetPost',
  // 削除画面遷移
  GO_DELETE: PREFIX + 'GoDelete',
  // ページ変更
  CHANGE_PAGE: PREFIX + 'ChangePage',
  // １ページの表示件数を変更
  CHANGE_VIEW_NUM: PREFIX + 'ChangeViewNum',
  // スクロール変更
  CHANGE_SCROLL_TOP: PREFIX + 'ChangeScrollTop',
  // 再検索フラグ更新
  SET_SEARCH_FLG: PREFIX + 'SetSearchFlg',
  // クリア
  CLEAR: PREFIX + 'Clear'
};
const groupHisaiSortActions = exports.groupHisaiSortActions = (0, _reduxActions.createActions)({
  // 検索条件変更
  [TYPES.CHANGE_SEARCH_CONDITION]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  // 検索結果設定
  [TYPES.SET_SEARCH_RESULT]: function () {
    return {
      searchResult: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  // 掲載先（グループ被災情報区分）設定
  [TYPES.SET_GROUPHISAI_KBN]: function () {
    return {
      kbnCd: arguments.length <= 0 ? undefined : arguments[0],
      kbnNm: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  // グループ被災情報詳細設定
  [TYPES.SET_GROUPHISAI_DETAIL]: function () {
    return {
      grouphisaiDetail: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  // 検索画面遷移
  [TYPES.GO_SEARCH]: function () {
    return {
      search: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  // 詳細画面遷移
  [TYPES.GO_DETAIL]: function () {
    return {
      selectSeq: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  // 掲載先設定画面遷移
  [TYPES.GO_SET_POST]: function () {
    return {
      selectSeq: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  // 削除画面遷移
  [TYPES.GO_DELETE]: function () {
    return {
      selectSeq: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  // ページ変更
  [TYPES.CHANGE_PAGE]: function () {
    return {
      currentPage: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  // １ページの表示件数を変更
  [TYPES.CHANGE_VIEW_NUM]: function () {
    return {
      viewNum: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  // スクロール変更
  [TYPES.CHANGE_SCROLL_TOP]: function () {
    return {
      scrollTop: arguments.length <= 0 ? undefined : arguments[0]
    };
  }
},
// 再検索フラグ更新
TYPES.SET_SEARCH_FLG,
// クリア
TYPES.CLEAR);
const groupHisaiSortReducer = exports.groupHisaiSortReducer = (0, _reduxActions.handleActions)({
  // 検索条件変更
  [TYPES.CHANGE_SEARCH_CONDITION]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), {}, {
      [action.payload.key]: action.payload.value
    })
  }),
  // 検索結果設定
  [TYPES.SET_SEARCH_RESULT]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    searchResult: action.payload.searchResult,
    // 検索結果を取得できたら、再検索フラグはOFFにする
    search: false,
    paging: INIT_STATE.paging
  }),
  // 掲載先（グループ被災情報区分）設定
  [TYPES.SET_GROUPHISAI_KBN]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    selectHisaiKbnCd: action.payload.kbnCd,
    grouphisaiDetail: _objectSpread(_objectSpread({}, state.grouphisaiDetail), {}, {
      hisaiKbn: action.payload.kbnNm
    })
  }),
  // グループ被災情報詳細設定
  [TYPES.SET_GROUPHISAI_DETAIL]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    grouphisaiDetail: action.payload.grouphisaiDetail
  }),
  // 検索画面遷移
  [TYPES.GO_SEARCH]: state => _objectSpread(_objectSpread({}, state), {}, {
    containerInfo: _objectSpread(_objectSpread({}, state.containerInfo), {}, {
      dispContent: CONTENTS.SEARCH
    })
  }),
  // 詳細画面遷移
  [TYPES.GO_DETAIL]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    selectSeq: action.payload.selectSeq,
    containerInfo: _objectSpread(_objectSpread({}, state.containerInfo), {}, {
      dispContent: CONTENTS.DETAIL
    })
  }),
  // 掲載先設定画面遷移
  [TYPES.GO_SET_POST]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    selectSeq: action.payload.selectSeq,
    selectHisaiKbnCd: INIT_STATE.selectHisaiKbnCd,
    containerInfo: _objectSpread(_objectSpread({}, state.containerInfo), {}, {
      dispContent: CONTENTS.SET_POST
    })
  }),
  // 削除画面遷移
  [TYPES.GO_DELETE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    selectSeq: action.payload.selectSeq,
    containerInfo: _objectSpread(_objectSpread({}, state.containerInfo), {}, {
      dispContent: CONTENTS.DELETE
    })
  }),
  // ページ変更
  [TYPES.CHANGE_PAGE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread(_objectSpread({}, state.paging), {}, {
      currentPage: action.payload.currentPage
    })
  }),
  // １ページの表示件数を変更
  [TYPES.CHANGE_VIEW_NUM]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread(_objectSpread({}, state.paging), {}, {
      currentPage: 0,
      viewNum: action.payload.viewNum
    })
  }),
  // スクロール変更
  [TYPES.CHANGE_SCROLL_TOP]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    containerInfo: _objectSpread(_objectSpread({}, state.containerInfo), {}, {
      scrollTop: action.payload.scrollTop
    })
  }),
  // 再検索フラグ更新
  [TYPES.SET_SEARCH_FLG]: state => {
    return _objectSpread(_objectSpread({}, state), {}, {
      // 再検索用フラグ（履歴一覧・検索結果一覧を再描画する）
      search: true
    });
  },
  // クリア
  [TYPES.CLEAR]: () => _objectSpread({}, INIT_STATE)
}, INIT_STATE);